import axios from '../config/axiosInterceptor'
export const URL = `lms/md`

export function FetchListApproval(params: any, id:number) {
  return new Promise((resolve, reject) => {
    axios.get(URL+ '/courses/show-list-approver/'+id, {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function ShowTemplate(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL+ '/courses/show-template', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function FetchUnit(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL+ '/unit/show', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function FetchJenisDiklat(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL+ '/jenis/show', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function FetchKategoriTable(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/kategori/show-table', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function FetchKategori(params: any, parent_sub:any, id2:any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/kategori/show-parent-sub/'+parent_sub+'/'+id2, {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const CreateKategori = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/kategori/store', payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const UpdateKategori = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/kategori/update/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const DeleteKategori = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/kategori/delete/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export function FetchTopik(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/topik/show', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const CreateTopik = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/topik/store', payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export function FetchCourses(params: any, id:any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show/'+id, {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function ShowCourseDetail(params: any, id:any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-detil-approved/'+id, {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function ShowCourseSection(params: any, id:any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-section/'+id, {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const UploadMateri = (payload: any) => {
  let formData = new FormData();

  Object.keys(payload).forEach(function(key) {
    formData.append(key, payload[key])
  });

  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/upload-file', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const CreateMateri = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/store', payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const UpdateMateri = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/update/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const DeleteMateri = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/delete/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const SubmitMateri = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/submit/' + id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const EditTanggalCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/update-validity-period/' + id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const DuplicateCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/duplicate/' + id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const PublishPosttest = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/active-post-test/' + id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const AssignPeserta = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/assign-peserta-sppt-manual/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export function FetchManagedCourses(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-manage', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const DaftarCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/daftar/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const MulaiCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/mulai/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const SaveStepCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/store-step/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const SubmitExam = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/submit-test/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const SubmitEval = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/submit-evaluasi', payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export function ShowRequestApprove(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-request-approve', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const ApprovalCourse = (payload: any, id:any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/courses/approve/'+id, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export const FetchParticipantFromSidiklat = (params: any) => {
  return new Promise((resolve, reject) => {
    axios.get(URL+ '/courses/show-peserta-external-source', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

export function FetchApprovalCourses(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-list-approval', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export function FetchMyCourses(params: any) {
  return new Promise((resolve, reject) => {
    axios.get(URL + '/courses/show-mycourse', {params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.log(error)
        reject(error.response);
      });
  })
}

export const SubmitCertificate = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios.post(URL+ '/coursessubmit-sertifikat', payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

